import { render, staticRenderFns } from "./RoleBadge.vue?vue&type=template&id=7a88be8a&scoped=true&"
import script from "./RoleBadge.vue?vue&type=script&lang=js&"
export * from "./RoleBadge.vue?vue&type=script&lang=js&"
import style0 from "./RoleBadge.vue?vue&type=style&index=0&id=7a88be8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a88be8a",
  null
  
)

/* custom blocks */
import block0 from "./RoleBadge.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports